module.exports = __webpack_public_path__ + "img/icon-1.dc49772e.png";